import React from 'react'
import PropTypes from 'prop-types'

import CampaignPlaceholder from 'assets/images/campaign/campaign_image_400x400-1.png'
import styles from './styles.scss'

const renderBanner = (brand) => {
  const { colour_secondary, colour_highlight } = brand

  const backgroundColor = colour_secondary || null
  const fontColor = colour_highlight || null

  return (
    <span className={styles.banner} style={{ backgroundColor: `#${backgroundColor}`, color: `#${fontColor}` }}>
      SOLD
    </span>
  )
}

const Comparable = (props) => {
  const {
    brand,
    campaignComparable: {
      address, default_image, suburb_name, bedrooms, bathrooms, carparks, price_guide, sold,
    },
  } = props

  return (
    <div className={styles.root}>
      <div className={styles.image} style={{ backgroundImage: default_image ? `url(${default_image})` : `url(${CampaignPlaceholder})` }}>
        {sold && renderBanner(brand)}
      </div>
      <div className={styles.details}>
        <span className={styles.price}>{price_guide}</span>
        <span className={styles.address}>
          {address}, {suburb_name}
        </span>
        <span className={styles.attributes}>
          {bedrooms} bed | {bathrooms} bath | {carparks} car
        </span>
      </div>
    </div>
  )
}

Comparable.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignComparable: PropTypes.object.isRequired,
}

export default Comparable
